import ReactDOM from "react-dom/client";
import "./index.css";
import "material-icons/iconfont/material-icons.css";
import { Route, BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// eslint-disable-next-line import/named
import { Loading } from "./utils/config/loader"
import fetchIntercept from 'fetch-intercept';
import { useEffect, useState } from "react";
import OktaAuth from "@okta/okta-auth-js";
import { LoginCallback, Security, SecureRoute } from "@okta/okta-react";
import { Header } from "./components/header/header";

import { config as configENV } from "../src/utils/config/config";

const issuer = `${configENV.ISSUER}`;
const clientId = `${configENV.CLIENT_ID}`;

const oktaAuth = new OktaAuth({
  issuer: issuer,
  redirectUri: window.location.origin + "/authorization-code/callback",
  postLogoutRedirectUri: window.location.origin + '/Account/PostLogout',
  clientId: clientId,
  responseType: 'code',
  scopes: ['openid', 'profile', 'email', 'groups']
});

const App: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingTimeout, setLoadingTimeout] = useState<NodeJS.Timeout | undefined>();


  useEffect(() => {
    const unregister = fetchIntercept.register({
      request: function (url, config) {
        // Annuler le délai précédent s'il existe
        if (loadingTimeout) clearTimeout(loadingTimeout);

        // Définir loading à true immédiatement
        setLoading(true);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return [url, config];
      },

      requestError: function (error) {
        return Promise.reject(error);
      },

      response: function (response) {
        // Attendre un délai minimum avant de cacher le loader
        const timeout = setTimeout(() => {
          setLoading(false);
        }, 1000); // 500 millisecondes ou la durée minimale de votre choix
        setLoadingTimeout(timeout);
        return response;
      },

      responseError: function (error) {
        // Même logique de délai pour les erreurs
        const timeout = setTimeout(() => {
          setLoading(false);
        }, 1000);
        setLoadingTimeout(timeout);
        return Promise.reject(error);
      },
    });

    // Nettoyer lors du démontage
    return () => {
      unregister();
      if (loadingTimeout) clearTimeout(loadingTimeout);
    };
  }, [loadingTimeout]);
  return (
    <>
      {loading && (
        <>
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div className="fixed inset-0 bg-black opacity-50"></div>
            <div className="fixed inset-0 z-50 flex justify-center items-center">
              <Loading show={loading} />
            </div>

          </div>


        </>
      )}

      <div className="font-Montserrat h-screen">
        {/* S'assurer que Router enveloppe tout */}
        <Security oktaAuth={oktaAuth} restoreOriginalUri={(_oktaAuth, originalUri) => {
          window.location.replace(originalUri || window.location.origin);
        }}>

          <div className="font-Montserrat h-screen">
            <Route path='/authorization-code/callback' component={LoginCallback} />
            {/* <Route render={() => <Redirect to="/authorization-code/callback" />} /> */}
            <SecureRoute path='/' component={Header} />

            {/* D'autres composants et routes ici */}
            <ToastContainer autoClose={2000} />
          </div>

        </Security>
      </div>

    </>
  );
};

const root = ReactDOM.createRoot(document.querySelector('#root') as HTMLElement);
root.render(<Router><App /></Router>);

/*
 * Some usefull links:
 * - react-router-dom : https://github.com/remix-run/react-router/blob/main/docs/getting-started/installation.md
 *         For the use of Link, BrowserRouter, Routes, Route and more
 * - Tailwind : https://tailwindcss.com/docs/installation
 *         For the css
 * - react-firebase-hooks : https://github.com/CSFrequency/react-firebase-hooks/tree/master/auth
 * - firebase : https://firebase.google.com/docs/web/setup
 *         For the connection with google
 * - material-icons : https://marella.me/material-icons/demo/
 *         For icons
 */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
